import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Typography, Grid, Tooltip, IconButton } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';
import { BackButton, localization, getDimensionsOfPagination } from '../../sc-utilities';
import { parseURL } from '../../sc-utilities';

import MaterialTable from 'material-table';
import DataRange from '../../sc-utilities/DateRange';
import * as actions from './store/colliHistoryActions';
import * as action from '../../np-core/Auth/store/authActions';
import moment from 'moment';

const styles = theme => ({
    "@global": {
        "[class*='buttonsCustomer']": {
            margin: theme.spacing(),
            fontSize: '13px',
            width: '100%',
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.buttonText.default
            },
        },
        "[class*='paletteButtons']": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.buttonText.default,
            margin: theme.spacing(),
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            height: "40px",
            padding: '2px',
            fontSize: '0.7rem'
        },
    },
    fab: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        marginLeft: theme.spacing(),
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    customToolbar: {
        marginLeft: 14,
        width: "900px",
        paddingTop: '4px'
    },
    tableTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
        paddingTop: '4px'
    },
    customTooltip: {
        marginLeft: -16,
        marginTop: '-2px'
    },
    dateTitle: {
        marginRight: 20
    },
});

let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];

const ColliHistoryList = props => {
    const { classes, translations, onFetchColliHistory, onFetchColliHistoryCount, fetching, saveColumnsFilter, activeCustomerID, tableColumns, tableRef } = props;
    const columnObject = useMemo(() => tableColumns
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , []);    const [dateRangeArrivedValue, setDateRangeArrivedValue] = useState({
        From: null,
        To: null,
        query: {}
    });

    const [dateRangeStartedValue, setDateRangeStartedValue] = useState({
        From: null,
        To: null,
        query: {}
    });

    const [dateRangeEndedValue, setDateRangeEndedValue] = useState({
        From: null,
        To: null,
        query: {}
    });

    const [dateRangeFinishedValue, setDateRangeFinishedValue] = useState({
        From: null,
        To: null,
        query: {}
    });

    const [tableOptions, setTableOptions] = useState({
        filtering: true,
        sorting: false,
        selection: false,
        exportButton: false,
        rowStyle: (_rowData, index) => {
            return { backgroundColor: index % 2 ? '#f3f3f3' : '#ffffff' };
        },
        search: false,
        minBodyHeight: window.innerHeight - 427 < 215 ? 215 : window.innerHeight - 427,
        maxBodyHeight: window.innerHeight - 427,
        pageSizeOptions: rowsPageSizeInit,
        columnsButton: true,
        pageSize: pageSize ? pageSize : 50,
        emptyRowsWhenPaging: false
    });

    const filterQuery = filters => {
        let obj = { ...parseURL(window.location.href) };
        for (var filter of filters) {
            obj[filter.column.field] = filter.value;
        }
        return obj;
    }

    async function fetchTableData(query) {
        let q = filterQuery(query.filters);
        
        query['ActiveCustomerID'] = activeCustomerID;
        query['q'] = q;
        query['ArrivedAtFrom'] = dateRangeArrivedValue.From ? moment(dateRangeArrivedValue.From).format('YYYY-MM-DD HH:mm:ss') : null;
        query['ArrivedAtTo'] = dateRangeArrivedValue.To ? moment(dateRangeArrivedValue.To).format('YYYY-MM-DD HH:mm:ss') : null;
        query['DateStartedFrom'] = dateRangeStartedValue.From ? moment(dateRangeStartedValue.From).format('YYYY-MM-DD HH:mm:ss') : null;
        query['DateStartedTo'] = dateRangeStartedValue.To ? moment(dateRangeStartedValue.To).format('YYYY-MM-DD HH:mm:ss') : null;
        query['DateEndFrom'] = dateRangeEndedValue.From ? moment(dateRangeEndedValue.From).format('YYYY-MM-DD HH:mm:ss') : null;
        query['DateEndTo'] = dateRangeEndedValue.To ? moment(dateRangeEndedValue.To).format('YYYY-MM-DD HH:mm:ss') : null;
        query['FinishedFrom'] = dateRangeFinishedValue.From ? moment(dateRangeFinishedValue.From).format('YYYY-MM-DD HH:mm:ss') : null;
        query['FinishedTo'] = dateRangeFinishedValue.To ? moment(dateRangeFinishedValue.To).format('YYYY-MM-DD HH:mm:ss') : null;

        let count = await onFetchColliHistoryCount(query);
        if (!query['page'] && query['pageSize'] !== 20 && query['pageSize'] !== 100) {
            let dimensions = getDimensionsOfPagination(count)
            query['pageSize'] = dimensions.pageSize
            rowsPageSizeInit = dimensions.rowsPageSize
            pageSize = dimensions.pageSize
        }
        let result = count ? await onFetchColliHistory(query) : [];
        setTableOptions({ ...tableOptions, pageSize: query['pageSize'], pageSizeOptions: rowsPageSizeInit });
        return { data: result, page: query.page, pageSize: pageSize, totalCount: count };
    }

    const filterDataRangeArrived = async (range) => {
        dateRangeArrivedValue.From = range.From
        dateRangeArrivedValue.To = range.To
        tableRef.current && tableRef.current.onQueryChange()
    };

    const filterDataRangeStarted = async (range) => {
        dateRangeStartedValue.From = range.From
        dateRangeStartedValue.To = range.To
        tableRef.current && tableRef.current.onQueryChange()
    };

    const filterDataRangeEnded = async (range) => {
        dateRangeEndedValue.From = range.From
        dateRangeEndedValue.To = range.To
        tableRef.current && tableRef.current.onQueryChange()
    };

    const filterDataRangeFinished = async (range) => {
        dateRangeFinishedValue.From = range.From
        dateRangeFinishedValue.To = range.To
        tableRef.current && tableRef.current.onQueryChange()
    };

    const tableTitle = () => {
        return <div className={classes.customToolbar} >
            <div className={classes.tableTitle}>
                {BackButton(translations, classes.customTooltip)}
                <Typography >{translations['colli_history'] || 'Colli history'}</Typography>
                <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} component="div" disabled={fetching} onClick={() => tableRef.current && tableRef.current.onQueryChange()}>
                        <Refresh />
                    </IconButton>
                </Tooltip>
            </div>
            <br />
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} id="date_arrived">
                    <Typography className={classes.dateTitle}>{translations['arrived'] || "Arrived"}</Typography>
                    <DataRange
                        label={translations['arrived'] || "Arrived"}
                        initialValues={dateRangeArrivedValue}
                        filterDataRange={filterDataRangeArrived}
                        value={dateRangeArrivedValue}
                        setValue={setDateRangeArrivedValue}
                        format="yyyy/MM/dd 00:00:00"
                        translations={translations}>
                    </DataRange>
                </Grid>
                <Grid item xs={12} sm={6} id="date_finished">
                    <Typography className={classes.dateTitle}> {translations['finished'] || 'Finished'} </Typography>
                    <DataRange
                        initialValues={dateRangeFinishedValue}
                        filterDataRange={filterDataRangeFinished}
                        value={dateRangeFinishedValue}
                        setValue={setDateRangeFinishedValue}
                        format="yyyy/MM/dd 00:00:00"
                        translations={translations}>
                    </DataRange>
                </Grid>
                <br />
                <Grid item xs={12} sm={6} id="date_started">
                    <Typography className={classes.dateTitle}>{translations['started'] || 'Started'}</Typography>
                    <DataRange
                        initialValues={dateRangeStartedValue}
                        filterDataRange={filterDataRangeStarted}
                        value={dateRangeStartedValue}
                        setValue={setDateRangeStartedValue}
                        format="yyyy/MM/dd 00:00:00"
                        translations={translations}>
                    </DataRange>
                </Grid>
                <Grid item xs={12} sm={6} id="date_ended">
                    <Typography className={classes.dateTitle}>{translations['ended'] || 'Ended'}</Typography>
                    <DataRange
                        initialValues={dateRangeEndedValue}
                        filterDataRange={filterDataRangeEnded}
                        value={dateRangeEndedValue}
                        setValue={setDateRangeEndedValue}
                        format="yyyy/MM/dd 00:00:00"
                        translations={translations}>
                    </DataRange>
                </Grid>
            </Grid>
        </div>
    }

    const columnHidden = newColumnState => {
        let objToSendColumn = {}
        let objColumns = {}
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden
            return objColumns
        })
        objToSendColumn[`ColliHistory`] = objColumns
        saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomerID })
        return newColumnState
    }

    return (
        <Paper>
            <MaterialTable
                tableRef={tableRef}
                title={tableTitle()}
                columns={columnObject}
                data={fetchTableData}
                options={tableOptions}
                isLoading={fetching}
                localization={localization(translations)}
                onChangeRowsPerPage={(size) => {
                    pageSize = size
                }}

                onChangeColumnHidden={columnHidden}
                onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
            />
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        fetching: state.logistic.colliHistory.fetching
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchColliHistoryCount: filter => dispatch(actions.fetchColliHistoryCount(filter)),
        onFetchColliHistory: filter => dispatch(actions.fetchColliHistory(filter)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ColliHistoryList));
